import React from 'react'

export default function EmailChatLogLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <a
      href={href}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()

        const customEvent = new CustomEvent('support-chat-action', { detail: { action: 'email_chat_log' } })
        window.dispatchEvent(customEvent)
      }}
    >
      {children}
    </a>
  )
}
